import {MCChatPreview} from '../../../api/proto';
import {IRawChat} from '../../RawChatsStore/RawChat';

export default function isPrivate(chat?: IRawChat | null): boolean {
  return chat?.type === MCChatPreview.Type.PRIVATE;
}
